/**
 * Match Liquid: show only the segment before " - " (scent / option label).
 * Radio value stays full variant.title for Shopify option matching.
 */
function stripPdpOptionTitle(value) {
  if (typeof value !== 'string' || !value.includes(' - ')) return value;
  const parts = value.split(' - ');
  return parts.length > 1 ? parts[0].trim() : value;
}

/**
 * PdpVariantPicker — manages visual state of variant picker labels.
 * VariantSelects (global.js) handles the core variant change logic.
 * This custom element only manages CSS class toggling + selected text updates.
 */
class PdpVariantPicker extends HTMLElement {
  connectedCallback() {
    this.labels = this.querySelectorAll('.pdp-variant-picker__item');
    this.selectedText = this.querySelector('.pdp-variant-picker__selected')
      || document.getElementById('pdp-selected-variant-' + this.dataset.section);

    this.addEventListener('change', this.handleInputChange.bind(this));

    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  handleInputChange(event) {
    if (!event.target.matches('.pdp-variant-picker__input')) return;
    const label = event.target.nextElementSibling;
    this.updateSelectedLabel(label);
    if (this.selectedText) {
      this.selectedText.textContent = stripPdpOptionTitle(event.target.value);
    }
  }

  handleVariantChange(event) {
    const variantId = event.data?.variant?.id;
    if (!variantId) return;

    const matchingLabel = this.querySelector(
      '.pdp-variant-picker__item[data-variant-id="' + variantId + '"]'
    );
    if (!matchingLabel) return;

    const matchingInput = matchingLabel.previousElementSibling;
    if (matchingInput && !matchingInput.checked) {
      matchingInput.checked = true;
    }
    this.updateSelectedLabel(matchingLabel);

    if (this.selectedText && matchingInput) {
      this.selectedText.textContent = stripPdpOptionTitle(matchingInput.value);
    }
  }

  updateSelectedLabel(activeLabel) {
    this.labels.forEach((label) => {
      label.classList.remove('pdp-variant-picker__item--selected');
    });
    if (activeLabel) {
      activeLabel.classList.add('pdp-variant-picker__item--selected');
    }
  }
}

customElements.define('pdp-variant-picker', PdpVariantPicker);
